export default {
	0: { name: 'WEEKLY' },
	0.5: { name: 'BIWEEKLY' },
	1: { name: 'MONTHLY' },
	2: { name: 'BIMONTHLY' },
	3: { name: 'QUARTERLY' },
	6: { name: 'BIANNUAL' },
	12: { name: 'ANNUAL' },
};
